const regexExps = {
  alphaNum: "^[A-Za-z0-9]+$",
  ssn: "^[A-Za-z\\d](?!666|9\\d{2})\\d{2}-\\d{2}-\\d{4}$",
  alphaChar: "^[A-Za-z\\s\\-']+$",
  numOnly: "^[0-9]+$",
  notOtherCountryPhone: "^\\d{3}-\\d{3}-\\d{4}$",
  otherCountryPhone: "^[+\\-\\s0-9]{10,}$",
  zipcodeUS: "^[0-9]{5}(?:-[0-9]{4})?$",
  zipcodeCanada: "^[A-Za-z][0-9][A-Za-z] ?[0-9][A-Za-z][0-9]$",
};

export default regexExps;
